import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as selfServiceActions } from "../redux/actions/selfServiceActions";
import LinearProgress from "@material-ui/core/LinearProgress";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { NavLink } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Alert from "@material-ui/lab/Alert";
import * as routeHelpers from "../authentication/routeHelpers";
import { Redirect } from "react-router-dom";

class EntitiesDashboard extends React.Component {
  componentDidMount() {
    this.props.requestEntities(true);
  }

  redirectToSingleEntity() {
    const entityId = this.props.entities[0].EntityChangeRequestID;
    return <Redirect to={routeHelpers.buildRoute(`/entities/${entityId}`)} />; //Redirect to single entity
  }

  render() {
    return (
      <>
        {this.props.isLoading ? (
          <>
            <div className="menu-loader-message">Loading entities...</div>
            <LinearProgress />
          </>
        ) : (
          <>
            {this.props.entities.length === 1 &&
            !this.props.requestSuccessMessage
              ? this.redirectToSingleEntity()
              : ""}

            <div style={{ marginTop: 20 }}>
              <Typography variant="h4" component="h2" color="primary">
                Welcome
              </Typography>
            </div>

            {this.props.entities &&
             this.props.entities.length === 0
             && 
              <p style={{ fontSize: 15, fontWeight: "bold" }}>
                 Congratulations, you do not have any pending change requests.
              </p>
            }
            {this.props.entities &&
             this.props.entities.length > 0
             && 
              <p style={{ fontSize: 15, fontWeight: "bold" }}>
                Fill in the required information for the following entities:
              </p>
            }

            {this.props.requestSuccessMessage ? (
              <Alert severity="success" style={{ marginBottom: 10 }}>
                {this.props.requestSuccessMessage}
              </Alert>
            ) : (
              <div></div>
            )}

            {this.props.entities.map((entity) => (
              <div key={entity.EntityChangeRequestID}>
                <ListItem
                  className="nav-list"
                  component={NavLink}
                  to={routeHelpers.buildRoute(`/entities/${entity.EntityChangeRequestID}`)}
                  button
                >
                  <ListItemText primary={entity.EntityName} />
                  <ArrowForwardIcon className="nav-icon" color="secondary" />
                </ListItem>
                <Divider style={{ marginBottom: 15 }} />
              </div>
            ))}
          </>
        )}
      </>
    );
  }
}

export default connect(
  (state) => state.selfService,
  (dispatch) => bindActionCreators(selfServiceActions, dispatch)
)(EntitiesDashboard);
